export const HttpMethod = {
  Get: "GET",
  Post: "POST",
  Put: "PUT",
  Patch: "PATCH",
  Delete: "DELETE",
};

const ApiRoutes = {
  Auth: {
    Login: {
      Endpoint: "/auth/login",
      Method: HttpMethod.Post,
    },
    Logout: {
      Endpoint: "/auth/logout",
      Method: HttpMethod.Post,
    },
    ChangePassword: {
      Endpoint: "/auth/change-password",
      Method: HttpMethod.Post,
    },
    Profile: {
      Endpoint: "/auth/details",
      Method: HttpMethod.Get,
    },
  },
  Order: {
    List: {
      Endpoint: "/admin/orders",
      Method: HttpMethod.Get,
    },

    DownloadInvoice: {
      Endpoint: (orderId) => `/admin/orders/invoice/${orderId}`,
      Method: HttpMethod.Get,
    },
  },
  Service: {
    List: {
      Endpoint: "/services",
      Method: HttpMethod.Get,
    },
  },
};
export default ApiRoutes;
